import { useMemo, useState } from 'react';
import '../App.css';
import TablePaginationComponent from './TablePaginationComponent';
import PropTypes from 'prop-types';

const FaultTable = (props) => {
    const { isLoading, faults, rowsPerPage } = props;

    const [page, setPage] = useState(1);

    const handleChange = (event, value) => {
        setPage(value);
    };

    const getFaultLevel = (level) => {
        switch (Number(level)) {
            case 1:
                return 'I';
            case 2:
                return 'II';
            default:
                return '';
        }
    };

    useMemo(() => {
        if (isLoading) {
            setPage(1);
        }
    }, [isLoading]);

    const columns = [
        { id: 'msg', label: 'Fault Description', align: 'left' },
        { id: 'carCode', label: 'Car No.', width: '60px', align: 'center' },
        { id: 'level', label: 'Level', width: '10px', align: 'center', format: (value) => { return getFaultLevel(value); } },
        {
            id: '',
            label: 'Status',
            width: '10px',
            align: 'center',
            format: (value, row) => {
                if (row.recoveryTime !== null) {
                    return 'Resolved';
                } else {
                    return 'Pending';
                }
            }
        },
        { id: 'dateTime', label: 'Time', width: '180px', align: 'center' },
        { id: 'stationCode', label: 'Location', width: '50px', align: 'center' },
        { id: 'routeCode', label: 'Route No.', width: '60px', align: 'center' },
        { id: 'faultTypeCode', label: 'Code', width: '50px', align: 'center' },
        { id: 'faultCatCode', label: 'System', width: '50px', align: 'center' },
    ];

    return (
        <TablePaginationComponent
            isLoading={isLoading}
            columns={columns}
            rows={faults}
            rowsPerPage={rowsPerPage}
            page={page}
            onChange={handleChange}
        />
    );
};

FaultTable.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    faults: PropTypes.array.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default FaultTable;